export type LeadDataLayerEvent = "lead_whatsapp" | "lead_form";

declare global {
	interface Window {
		dataLayer?: Record<string, unknown>[];
	}
}

export function pushDataLayerEvent(event: LeadDataLayerEvent) {
	if (typeof window === "undefined") return;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ event });
}
